/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { defaultTheme } from '@vital-ui/react-theme';
import cn from 'classnames';
import { superBoxStyle } from '@vital-ui/react-utils';
import { AvatarBadge } from './AvatarBadge';
import { defaultAvatarSets } from './default-avatar';
var sizeStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n"], ["\n  width: ",
    ";\n  height: ",
    ";\n  border-radius: ",
    ";\n"])), function (_a) {
    var size = _a.size, theme = _a.theme, builtinTheme = _a.builtinTheme;
    if (typeof size === 'number') {
        return size + 'px';
    }
    return getBuiltInOrTheme(builtinTheme, theme)[size].size;
}, function (_a) {
    var size = _a.size, theme = _a.theme, builtinTheme = _a.builtinTheme;
    if (typeof size === 'number') {
        return size + 'px';
    }
    return getBuiltInOrTheme(builtinTheme, theme)[size].size;
}, function (_a) {
    var size = _a.size, circle = _a.circle, theme = _a.theme, builtinTheme = _a.builtinTheme;
    if (typeof size === 'number') {
        return circle ? '50%' : '3px';
    }
    return circle
        ? '50%'
        : getBuiltInOrTheme(builtinTheme, theme)[size].borderRadius;
});
var Root = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  ", ";\n  ", ";\n"], ["\n  position: relative;\n  display: inline-block;\n  ",
    ";\n  ", ";\n"])), function (_a) {
    var circle = _a.circle;
    return circle && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-radius: 50%;\n    "], ["\n      border-radius: 50%;\n    "])));
}, superBoxStyle);
var Image = styled('img')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  box-sizing: border-box;\n  ", ";\n"], ["\n  background-color: ", ";\n  box-sizing: border-box;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.grey200;
}, sizeStyle);
var ImageWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  overflow: hidden;\n  ", ";\n"], ["\n  overflow: hidden;\n  ", ";\n"])), sizeStyle);
ImageWrapper.defaultProps = {
    theme: defaultTheme,
};
Image.defaultProps = {
    theme: defaultTheme,
};
/**
 * @render react
 * @name Avatar
 * @description Vital UI Kit Avatar Component
 * @example
 * <Avatar
 *  badge="99+"
 *  size="large"
 *  gender="male"
 *  circle
 * />
 */
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDefaultAvatar = function () {
            var _a = _this.props, outline = _a.outline, gender = _a.gender, bulltinAvatars = _a.bulltinAvatars, size = _a.size, builtinTheme = _a.builtinTheme, _b = _a.theme, theme = _b === void 0 ? defaultTheme : _b;
            var sizeTheme = getBuiltInOrTheme(builtinTheme, theme);
            var defaultAvatarRenderer = bulltinAvatars || defaultAvatarSets;
            var avatarSize = typeof size === 'number' ? size : sizeTheme[size].size;
            var avatarProps = {
                width: avatarSize,
                height: avatarSize,
            };
            if (outline && gender) {
                if (gender === 'female') {
                    return defaultAvatarRenderer.femaleOutline(avatarProps);
                }
                if (gender === 'male') {
                    return defaultAvatarRenderer.maleOutLine(avatarProps);
                }
                return defaultAvatarRenderer.outline(avatarProps);
            }
            if (!outline && gender) {
                if (gender === 'female') {
                    return defaultAvatarRenderer.female(avatarProps);
                }
                if (gender === 'male') {
                    return defaultAvatarRenderer.male(avatarProps);
                }
                return defaultAvatarRenderer.default(avatarProps);
            }
            if (outline && !gender) {
                return defaultAvatarRenderer.outline(avatarProps);
            }
            return defaultAvatarRenderer.default(avatarProps);
        };
        _this.renderBadge = function () {
            var _a = _this.props, badge = _a.badge, size = _a.size, circle = _a.circle, badgeStyle = _a.badgeStyle, badgeClassName = _a.badgeClassName;
            if (!badge) {
                return null;
            }
            if (typeof badge === 'string' || typeof badge === 'number') {
                // FIXME: We skip the size calc since AvatarBadge now doesn't support number;
                return (
                // @ts-ignore
                React.createElement(AvatarBadge
                // @ts-ignore
                , { 
                    // @ts-ignore
                    className: cn('vital__avatar-badge', badgeClassName), label: badge, 
                    // @ts-ignore
                    size: typeof size === 'number' ? 'medium' : size, circle: circle, style: badgeStyle }));
            }
            return badge;
        };
        return _this;
    }
    Avatar.prototype.render = function () {
        var _a = this.props, src = _a.src, circle = _a.circle, _b = _a.size, size = _b === void 0 ? 'medium' : _b, badge = _a.badge, outline = _a.outline, gender = _a.gender, style = _a.style, imageStyle = _a.imageStyle, badgeStyle = _a.badgeStyle, containerClassName = _a.containerClassName, imageClassName = _a.imageClassName, badgeClassName = _a.badgeClassName, props = __rest(_a, ["src", "circle", "size", "badge", "outline", "gender", "style", "imageStyle", "badgeStyle", "containerClassName", "imageClassName", "badgeClassName"]);
        return (React.createElement(Root, __assign({ circle: circle, style: style, className: cn('vital__avatar', containerClassName) }, props),
            src ? (React.createElement(Image, { className: cn('vital__avatar-image', imageClassName), src: src, size: size, circle: circle, style: imageStyle })) : (React.createElement(ImageWrapper, { className: cn('vital__avatar-image-wrapper'), size: size, circle: circle }, this.renderDefaultAvatar())),
            this.renderBadge()));
    };
    Avatar.defaultProps = {
        bulltinAvatars: defaultAvatarSets,
        circle: false,
        size: 'medium',
        outline: false,
    };
    Avatar.Badge = AvatarBadge;
    return Avatar;
}(React.Component));
export { Avatar };
function getBuiltInOrTheme(builtin, theme) {
    return builtin ? builtin : theme.avatar || constants;
}
var constants = {
    small: {
        size: '24px',
        borderRadius: '2px',
        badgeHeight: '7px',
    },
    medium: {
        size: '32px',
        borderRadius: '3px',
        badgeHeight: '9px',
    },
    large: {
        size: '48px',
        borderRadius: '4px',
        badgeHeight: '13px',
    },
    xlarge: {
        size: '64px',
        borderRadius: '4px',
        badgeHeight: '17px',
    },
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Avatar.js.map